module.exports = "/public/images/1bec68690c4e8be642ed6b42d653befe.png";